const store = {
  namespaced: true,
  state: {
    onAccountManageRow: {},
    currentTabTypeAccount: "payment-customer"
  },
  getters: {},
  mutations: {
    setOnAccountManageRow(state, comState) {
      state.onAccountManageRow = comState;
    },
    setAccountCurrentTabType(state, data) {
      state.currentTabTypeAccount = data;
    }
  },
  actions: {
    async queryIncomeExpenseMethodList({ rootState }, params = {}) {
      const data = await rootState.http("/report/queryIncomeExpenseMethodList", params);
      return data;
    },
    async statisticOnAccount({ rootState }, params = {}) {
      const data = await rootState.http("/order/statisticOnAccount", params);
      return data;
    },
    async getCustomerUnpaidOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/getCustomerUnpaidOrder", params);
      return data;
    },
    async queryOnAccountCustomer({ rootState }, params = {}) {
      const data = await rootState.http("/order/queryOnAccountCustomer", params);
      return data;
    },
    async getReceiptDetail({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/getReceipt", params);
      return data;
    },
    async getReceiptList({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/queryReceiptList", params);
      return data;
    },
    async createGeneralReceipt({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/createOrderReceipt", params);
      return data;
    },
    async createOtherReceipt({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/createOtherReceipt", params);
      return data;
    },
    async getPaymentDetail({ rootState }, params = {}) {
      const data = await rootState.http("/payment/getPayment", params);
      return data;
    },
    async getPaymentList({ rootState }, params = {}) {
      const data = await rootState.http("/payment/queryPaymentList", params);
      return data;
    },
    async createOtherPayment({ rootState }, params = {}) {
      const data = await rootState.http("/payment/createPaymentOther", params);
      return data;
    },
    async getBillList({ rootState }, params = {}) {
      const data = await rootState.http("/tmallbill/queryBillList", params);
      return data;
    },
    async getBillDetail({ rootState }, params = {}) {
      const data = await rootState.http("/tmallbill/getBillDetail", params);
      return data;
    },
    async confirmBill({ rootState }, params = {}) {
      const data = await rootState.http("/tmallbill/confirmBill", params);
      return data;
    },
    async confirmBillReceived({ rootState }, params = {}) {
      const data = await rootState.http("/tmallbill/receiveBill", params);
      return data;
    },
    async queryGitiWechatAppBillList({ rootState }, params = {}) {
      const data = await rootState.http("/pcrMiniBill/queryBillList", params);
      return data;
    },
    async queryGitiWechatAppBillDetail({ rootState }, params = {}) {
      const data = await rootState.http("/pcrMiniBill/getBillDetail", params);
      return data;
    },
    async confirmGitiWechatAppBill({ rootState }, params = {}) {
      const data = await rootState.http("/pcrMiniBill/confirmBill", params);
      return data;
    },
    async gitiWechatAppBillReceived({ rootState }, params = {}) {
      const data = await rootState.http("/pcrMiniBill/receiveBill", params);
      return data;
    },
    async getInvoiceList({ rootState }, params = {}) {
      const data = await rootState.http("/invoice/queryInvoiceList", params);
      return data;
    },
    async getGrossProfitList({ rootState }, params = {}) {
      const data = await rootState.http("/report/queryGrossProfit", params);
      return data;
    },
    async getGrossProfitReport({ rootState }, params = {}) {
      const data = await rootState.http("/report/statisticTrendGrossProfit", params);
      return data;
    },
    async getItemProductionValue({ rootState }, params = {}) {
      const data = await rootState.http("/report/queryItemProductionValue", params);
      return data;
    },
    async getIncomeExpenseReport({ rootState }, params = {}) {
      const data = await rootState.http("/report/v2/incomeExpenseStatisticTrend", params);
      return data;
    },
    async getIncomeExpenseSum({ rootState }, params = {}) {
      const data = await rootState.http("/report/v2/queryIncomeExpenseResult", params);
      return data;
    },
    async queryPurchaseBillList({ rootState }, params = {}) {
      const data = await rootState.http("/purchasebill/queryBillList", params);
      return data;
    },
    async savePurchaseBill({ rootState }, params = {}) {
      const data = await rootState.http("/purchasebill/savePurchaseBill", params);
      return data;
    },
    async queryPurchaseBillDetail({ rootState }, params = {}) {
      const data = await rootState.http("/purchasebill/getBillDetail", params);
      return data;
    },
    async createPurchaseBillSettlement({ rootState }, params = {}) {
      const data = await rootState.http("/purchasebill/settlePurchaseBill", params);
      return data;
    },
    async createPurchaseBillInvoice({ rootState }, params = {}) {
      const data = await rootState.http("/purchasebill/invoicePurchaseBill", params);
      return data;
    },
    async calcCustomerOrder({ rootState }, params = {}) {
      const data = await rootState.http("/store/order/calcCustomerOrder", params);
      return data;
    },
    async salesOrderReportQueryList({ rootState }, params = {}) {
      const data = await rootState.http("/report/salesOrderReport/queryList", params);
      return data;
    },
    async getGrossProfitReportV2({ rootState }, params = {}) {
      const data = await rootState.http("/report/v2/statisticTrendGrossProfit", params);
      return data;
    },
    async getGrossProfitListV2({ rootState }, params = {}) {
      const data = await rootState.http("/report/v2/queryGrossProfit", params);
      return data;
    }
  }
};

export default store;
